export default __webpack_public_path__ + "static/media/microsoftsamlguide.0f945f29.png";